// extracted by mini-css-extract-plugin
export default {"container":"CurrentMonthIndicator_container__+nwnZ","el":"CurrentMonthIndicator_el__tPLRh"};